import {
  AutomationTaskInput,
  RequirementConditionType
} from 'services/automation/types';

const isRequirementConditionsEqual = (
  task: AutomationTaskInput,
  nextTask: AutomationTaskInput
) => {
  const isRequirementConditionsEqual = task.requirementConditions.every(
    (condition, index) => {
      const nextCondition = nextTask.requirementConditions[index];

      if (
        condition.type ===
          RequirementConditionType.CANDIDATE_STATUS_CONDITION &&
        nextCondition.type ===
          RequirementConditionType.ANY_CANDIDATE_STATUS_CONDITION
      ) {
        return true;
      }

      return (
        // Using loose equality to compare the values because the values can be null or undefined
        condition.type == nextCondition.type &&
        condition.operator == nextCondition.operator &&
        condition.scoreScaled == nextCondition.scoreScaled &&
        condition.candidateStatus == nextCondition.candidateStatus &&
        condition.conversationStatus == nextCondition.conversationStatus
      );
    }
  );

  return isRequirementConditionsEqual;
};

/**
 * @deprecated use modules/analyse
 */
export const findDuplicatedAutomationTasks = (
  automationTasks: AutomationTaskInput[]
) => {
  const duplicates: AutomationTaskInput[] = [];

  automationTasks.forEach((task, index) => {
    const isDuplicate = automationTasks.some((nextTask, nextIndex) => {
      if (index !== nextIndex) {
        const isRequirementConditionsEqualValue = isRequirementConditionsEqual(
          task,
          nextTask
        );

        const isActionEqual = nextTask.action.type === task.action.type;
        return isRequirementConditionsEqualValue && isActionEqual;
      }
      return false;
    });

    if (isDuplicate) {
      duplicates.push(task);
    }
  });

  return duplicates;
};
